/*
Copyright 2019 BiZ9 Framework
Author: Brandon Poole (biz9framework@gmail.com)
License GNU General Public License v3.0
Description: BiZ9 Framework: Utility
*/
const prettydate = require("pretty-date");
const dayjs = require('dayjs');

class Status_Type{
    static FAIL = 'FAIL';
    static OK = 'OK';
    static SUCCESS = 'SUCCESS';
}
class Response_Field{
    static TITLE = 'title';
    static APP_ID = 'app_id';
    static ERROR = 'error';
    static PROJECT_TITLE = 'project_title';
    static MESSAGES = 'messages';
    static STATUS = 'status';
    static TYPE = 'type';
    static RESPONSE_RESULT = 'param_response_result';
    static PARAM_APP_ID = 'param_app_id';
    static PARAM_FORM_DATA = 'param_form_data';
    static PARAM_DATA = 'param_data';
    static PARAM_OPTION = 'param_option';
    static PARAM_URL = 'param_url';
    static DELETE_CONFIRM = 'delete_confirm';
    static DELETE_FAIL = 'delete_fail';
    static GET_CONFIRM = 'get_confirm';
    static GET_FAIL = 'get_fail';
    static POST_CONFIRM = 'post_confirm';
    static POST_FAIL = 'post_fail';
    static PING_CONFIRM = 'ping_confirm';
}
class Response_Logic{
    /* - DEFINE -
     * -- LOGIC --
     * --- Get New Response ---
     * let response = Response_Logic.get_response();
     * response.messages.push(Response_Logic.get_message(Response_Field.PARAM_APP_ID,Status_Type.OK,'app_id',{title:Config.TITLE}));
     * Response_Logic.print(Response_Logic.get_status(response));
     */
    static get_response = () => {
        return {status:Status_Type.OK,messages:[]};
    }
    static print = (response) => {
        console.log('-- PRINT RESPONSE --');
        Log.w('Status',response.status);
        for(const message of response.messages){
            console.log('-- MESSAGE --');
            Log.w('Type',message.type);
            Log.w('Status',message.status);
            Log.w('Message',message.message);
        }
    }
    static get = () => {
        return Response_Logic.get_response({status:Status_Type.OK,messages:[]});
    }
    static get_response_by_response = (status,type,message) => {
        return {status:status,type:type,message:message};
        /*
        const message_items = [];
        return {status:status,type:type,message: [...message_items, ...message]};
        */
    }
    static get_message = (type,status,message,option) => {
        option = !Obj.check_is_empty(option) ? option : {};
        let title = !Obj.check_is_empty(option.title) ? option.title : '';
        return {type:type,status:status,message:message,title:title};
    }
    static get_status = (response) => {
        let item_match_fail = Obj.find_last(Response_Field.STATUS,Status_Type.FAIL,response.messages);
        let item_match_success = Obj.find_last(Response_Field.STATUS,Status_Type.SUCCESS,response.messages);
        let item_match_ok = {};

        if(item_match_success){
            response.status = item_match_success.status;
            response.message = Str.check_is_null(item_match_success.message) ? '' : item_match_success.message;
        }
        else if(item_match_fail){
            response.status = item_match_fail.status;
            response.message = Str.check_is_null(item_match_fail.message) ? '' : item_match_fail.message;
        }
        if(!item_match_fail && !item_match_success){
            item_match_ok = Obj.find_last(Response_Field.STATUS,Status_Type.OK,response.messages);
            if(item_match_ok){
                response.status =  item_match_ok.status;
                response.message =  Str.check_is_null(item_match_ok.message) ? '' : item_match_ok.message;
            }
        }
        if(!item_match_fail && !item_match_success && !item_match_ok){
            response.status =  Status_Type.OK;
            response.message =  '';
        }
        return response;
    }
}
class Form{
    static set_item = (data_type,id,item_data,option) => {
        if(!data_type){
            data_type='dt_blank';
        }
        if(!id){
            id=0;
        }
        var item={};
        for (key in item_data) {
            item[key]=String(item_data[key]).trim();
        }
        item['id']=id;
        item['data_type']=data_type;
        if(!option){
            option = {};
        }
        if(option){
            for (const key in option) {
                item[key] = option[key];
            }
        }
        return item;
    };
}
class Log{
    static w = (title,str) => {
        if(!str){
            str=null;
        }
        if(str){
            console.log("-- "+Str.get_upper_case(title) + " --","\n", str);
            console.log("______");
        }else{
            console.log("-- "+ title +" --");
            console.log("______");
        }
    };
    static error = (title,str) => {
        if(!str){
            str=null;
        }
        if(str){
            console.error("-- "+Str.get_upper_case(title) + " --", str);
            console.error("___");
        }else{
            console.error("**-- "+title +" --");
        }
    };
    static append = (message,new_message) => {
        let append = false;
        if(new_message){
            if(!message){
                message='';
                append=true;
            }
            if(append){
                new_message = ' ' + new_message + ",";
                message = message + new_message
            }
        }
        return message;
    };
}
class Num {
    static get_id = (max,option) => {
        option = !Obj.check_is_empty(option) ? option : {non_zero:true};
        if(!max){
            max = 99999;
        }
        let min = option.non_zero ? 1 : 0;
        return Math.floor(Math.random() * (max - min)) + min;
    };
    static get_decimal = (n,decimal) => {
        if(!n){
            n=0;
        }
        if(!decimal){
            decimal = 1;
        }
        return parseFloat(n).toFixed(decimal);
    };
    static get_discount = (old_cost, now_cost) => {
        if(isNaN(old_cost)){
            old_cost=parseFloat(0.00);
        }
        if(isNaN(now_cost)){
            now_cost=parseFloat(0.00);
        }
        let discount = old_cost - now_cost;
        let r_discount  = String(parseInt(((discount / old_cost) * 100))) + "%";
        if(isNaN(r_discount)){
            r_discount=parseFloat(0.00) + "%";
        }
        return r_discount;
    };
}
class Obj {
    static find = (field,value,items) => {
        if(!items){
            items = [];
        }
        return items.find(item_find => item_find[field] === value) ? items.find(item_find => item_find[field] === value) : null;
    }
    static find_last = (field,value,items) => {
        if(!items){
            items = [];
        }
        return items.findLast(item_find => item_find[field] === value) ?  items.findLast(item_find => item_find[field] === value) : null;
    }
    static filter = (field,value,items) => {
        if(!items){
            items = [];
        }
        return items.filter(item_find => item_find[field] === value) ? items.filter(item_find => item_find[field] === value) : null;
    }
    static filter_remove = (field,value,items) => {
        if(!items){
            items = [];
        }
        return items.filter(item_find => item_find[field] != value);
    }
    static filter_empty_field = (field,items) => {
        if(!items){
            items = [];
        }
        return items.filter(item_find => !item_find[field]);
    }
    static sort_items_by_field = (items,sort_field,sort_type) => {
        if(!sort_type){
            sort_type='asc'; //asc, desc
        }
        if(sort_type=='asc'){
            return items.sort((a, b) => a[sort_field].localeCompare(b[sort_field]));
        }else{
            return items.sort((a, b) => b[sort_field].localeCompare(a[sort_field]));
        }
    }
    static parse_json = (value) => {
        return JSON.parse(value);
    }
    static merge = (obj1, obj2) => {
        return {...obj1, ...obj2};
    }
    static merge_items = (items_1, items_2) => {
        return [...items_1, ...items_2];
    }
    static check_is_empty = (obj) => {
        let is_null = false;
        if(!obj){
            obj = {};
        }
        let check_obj =  Object.keys(obj).length === 0 && obj.constructor === Object;
        is_null = check_obj;
        if(check_obj === null){
            is_null = true;
        }
        return is_null;
    };
    static check_has_array = (obj) =>{
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                if (Array.isArray(obj[key])) {
                    return true; // Found a property that is an array
                }
            }
        }
        return false; // No array property found
    };
    static check_is_value(val) {
        //check is not array or object
        return typeof val !== 'object' || val === null;
    }
    static check_is_array = (obj) =>{
        return Array.isArray(obj);
    }
    static check_is_object = (value) =>{
        return value === null || (typeof value !== 'object' && typeof value !== 'function');
    }
    static get_distinct = (src_items, distinct_field) => {
        return src_items.filter((obj, index, self) =>
            index === self.findIndex((t) => t[distinct_field] === obj[distinct_field])
        );
    }
    static get_shuffle_items = (items) => {
        for (let i = items.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [items[i], items[j]] = [items[j], items[i]];
        }
        return items;
    }
    static get_random_items = (items,count) => {
        // Prevent infinite loops if asking for more items than exist
        if (count > items.length) {
            throw new Error("Count cannot be greater than array length");
        }
        const indices = new Set();
        while (indices.size < count) {
            const randomIndex = Math.floor(Math.random() * items.length);
            indices.add(randomIndex); // Sets only store unique values
        }
        // Map the random indices back to the actual array items
        return Array.from(indices).map(index => items[index]);
    }
}
class Str {
    static get_quill_html = (str) => {
        if (!str) return "";
            return str.replace(/&nbsp;/g, " ");
    };
    static print_array = (items) => {
        return items.toString();
    };
    static get_regex_pipe = (value) => {
        return value.replace(/[^\w]+/g, '|');
    };
    static get_guid = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    static get_hex = () => {
        const chars = '0123456789abcdef';
        let result = '';
        for (let i = 0; i < 25; i++) {
            result += chars[Math.floor(Math.random() * 16)];
        }
        return result;
    };
    static get_id = (max,option) => {
        option = !Obj.check_is_empty(option) ? option : {non_zero:true};
        if(!max){
            max = 99999;
        }
        let min = option.non_zero ? 1 : 0;
        return  String(Math.floor(Math.random() * (max - min)) + min);
    };
    static check_is_guid = (str) => {
        const guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
        return guidRegex.test(str);
    };
    static get_cent = (n) => {
        return  parseInt((Number(n)*100)).toString();
    };
    static get_upper_case = (str) => {
        if(!str){
            str='';
        }
        return str.toUpperCase();
    }
    static get_plural = (str) => {
        if(!str){
            str='';
        }
        return str + "s";
    }
    static get_trim = (str) => {
        if(!str){
            str='';
        }
        return str.trim();
    }
    static get_title = (str,plural) => {
        if(!str){
            str='';
        }
        if(plural){
            str = str + "s";
        }
        return str.replace(/\w\S*/g,text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase());
    };
    static get_lower_case = (str) => {
        if(!str){
            str = '';
        }
        return str.toLowerCase();
    };
    static check_is_null = (str) => {
        if(!str){
            return true;
        }
        else if(str == null){
            return true;
        }
        else if(typeof str === 'undefined') {
            return true;
        }
        else if(str === undefined) {
            return true;
        }
        else if(String(str) == 'undefined') {
            return true;
        }
        else if(String(str) == undefined) {
            return true;
        }
        else if(str.length === 0){
            return true;
        }
        else if(str.length==0){
            return true;
        }
        else if(str === undefined || str == 0 || str == '0'){
            return true;
        }
        else if(String(str) =='null'){
            return true;
        }else{
            return false;
        }
    };
    static check_is_true = (str) => {
        if(Str.check_is_null(str)){
            return false;
        }else{
            const lowerStr = str.toString().toLowerCase();
            return lowerStr === "true" || lowerStr === "yes" || lowerStr === "on" || lowerStr === "1";
        }
    };
    static get_title_url = (title) => {
        if(!title){
            title='';
        }
        return String(title).replace(/[^a-z0-9]+/ig, "_").toLowerCase();
    };
    static get_truncate = (str,max) => {
        if(!str){
            str = '';
        }
        if (str.length > max) {
            return str.substring(0, max) + "...";
        } else {
            return str;
        }
    };
    static validate_email = (email) => {
        if(!email){
            return 'Email is not valid';
        }
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(!re.test(String(email).toLowerCase())){
            return 'Email is not valid.';
        }else{
            return true;
        }
    };
    static validate_username = (username) => {
        if(!username){
            username = '';
        }
        const minLength = 3;
        const maxLength = 31;
        if (username.length < minLength || username.length > maxLength) {
            return "Username must be between " + minLength + " and " + maxLength + " characters long.";
        }
        return true; // All checks passed
    }
    static validate_password = (password) => {
        if(!password){
            password = '';
        }
        const minLength = 7;
        const maxLength = 15;
        // Check length
        if (password.length < minLength || password.length > maxLength) {
            return "Password must be between " + minLength + " and " + maxLength + " characters long.";
        }
        // Check for at least one uppercase letter
        if (!/[A-Z]/.test(password)) {
            return "Password must contain at least one uppercase letter.";
        }
        // Check for at least one lowercase letter
        if (!/[a-z]/.test(password)) {
            return "Password must contain at least one lowercase letter.";
        }
        // Check for at least one digit
        if (!/\d/.test(password)) {
            return "Password must contain at least one digit.";
        }
        // Check for at least one special character
        if (!/[!@#$%^&*()]/.test(password)) { // You can expand this set of special characters
            return "Password must contain at least one special character.";
        }
        return true; // All checks passed
    };
    static get_photo = (photo_data) => {
        return photo_data = photo_data ? photo_data : "no_img.jpg";
    };
    static get_capital_first_letter = (str) => {
        if(Str.check_is_null(str)){
            str = "";
        }
        const words = str.split(' ');
        const capitalizedWords = words.map(word => {
            if (word.length === 0) {
                return '';
            }
            return word.charAt(0).toUpperCase() + word.slice(1);
        });
        return capitalizedWords.join(' ');
    };
    static get_remove_whitespace = (str) => {
        if(Str.check_is_null(str)){
            str = "";
        }
        const words = str.split(' ');
        const capitalizedWords = words.map(word => {
            if (word.length === 0) {
                return '';
            }
            return word.charAt(0).toUpperCase() + word.slice(1);
        });
        return capitalizedWords.join(' ');
    };
    static check_is_base64 = (str) => {
        const base64RegExp = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})$/;
        return base64RegExp.test(str);
    };
    static get_money = (n) => {
        n = parseFloat(n);
        if(!n || isNaN(n)){
            n = 0;
        }
        return "$"+n.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    };
    static get_file_extension = (file_name) => {
        const match = file_name.match(/\.([^.]+)$/);
        if (match) {
            return match[1];
        }
    };
    static check_if_str_exist = (src_str,val) => {
        function escapeRegExp(string) {
            return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        }
        const regex = new RegExp(escapeRegExp(val), 'i');
        return regex.test(src_str);
    };
    static check_is_hex = (value) =>{
        const regex = /^[0-9a-fA-F]{24}$/;
        if(!value){
            return false;
        }
        if (regex.test(value)) {
            return true;
        } else {
            return false
        }
    };
    static check_is_image = (filename) =>{
        let is_true = false;
        const imageExtensions = /\.(jpg|jpeg|png|gif|bmp|webp|svg|svg+xml)$/i;
        is_true =  imageExtensions.test(filename);
        const regex = /svg\+xml/;
        if(!is_true){
            is_true = regex.test(filename);
        }
        return is_true;
    };
    static check_has_alpha = (str) =>{
        // This regex will return true if it finds at least one alpha character
        const alphaRegex = /[a-zA-Z]/;
        return alphaRegex.test(str);
    }
    static get_table_by_name = (table,option) =>{
        table = table?String(table):String("");
        let table_title = "";
        option = option ? option : {lowercase:false,plural:false,url:false};
        table_title = String(Str.get_title(table.replaceAll('_',' ').replace('biz',''))).trim();
        if(option.plural){
            table_title = table_title + 's';
        }
        if(option.lowercase){
            table_title = table_title.toLowerCase();
        }
        if(option.url){
            table_title = table_title.replace(" ","_").toLowerCase();
        }
        return table_title;
    };
}
class DateTime {
    static get_pretty = (date_time) => {
        return prettydate.format(new Date(date_time));
    };
    static get = (option) => {
        option = option ? option : {};
        if(option.format){
            return dayjs().format(option.format);
        }else{
            return dayjs().toISOString();
        }
    };
    static get_date_time = (date_time,option) => {
        //(date + ' ' +  time) = will print given format
        option = option ? option : {format:"dddd MMMM D, YYYY h:mm a"};
        const dateObj = dayjs(date_time);
        return dateObj.format(option.format);
    };
    static get_date = (date,option) => {
        option = option ? option : {format:"dddd MMMM D, YYYY"};
        const dateObj = dayjs(date);
        return dateObj.format(option.format);
    };
    static get_time = (time,option) => {
        option = option ? option : {format:"h:mm a"};
        const timeObj = dayjs(time);
        return timeObj.format(option.format);
    };
    static get_month = (date_time,option) => {
        option = option ? option : {format:"MMMM"};
        return DateTime.get_date_time(date_time,{format:option.format});
    };
    static get_year = (date_time,option) => {
        option = option ? option : {format:"YYYY"};
        return DateTime.get_date_time(date_time,{format:option.format});
    };
    static get_day = (date_time,option) => {
        option = option ? option : {format:"dddd"};
        return DateTime.get_date_time(date_time,{format:option.format});
    };
    static get_date_short = (date_time,option) => {
        //25 May 2025
        option = option ? option : {format:"D MMMM YYYY"};
        return DateTime.get_date_time(date_time,{format:option.format});
    };
    static get_obj = (date) => {
        return dayjs();
    };
}
module.exports = {
    Log,
    Response_Logic,
    Response_Field,
    Status_Type,
    Num,
    Str,
    Obj,
    Form,
    DateTime
};
